import React from 'react';
import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { IconCtaSimplified } from '@ahc-digital/component-library';
import { CreateIconCTASimplified } from './C30IconCTASimplified.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import {
  RenderingProps,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
} from 'src/shared/shared.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C30IconCTASimplifiedProps = RenderingProps<
  C30IconCTASimplifiedFields,
  {
    TitleType?: string;
    NumberOfColumns?: string;
    MobileBehavior?: string;
  } & DynamicPlaceholderParams &
    TranslationOptionsParams &
    AnchorTargetParams
>;

export type C30IconCTASimplifiedFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  BottomSupportCopy?: RichTextField;
};

export const Default = (props?: C30IconCTASimplifiedProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <IconCtaSimplified
      id={props?.params?.AnchorLinkTargetName}
      {...CreateIconCTASimplified(props)}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};
